// extracted by mini-css-extract-plugin
export default {"genericIcon":"GenericIcon_genericIcon__2cBCh"};